<script lang="ts">
	import Modal from "../Modal.svelte";
	import CareerForm from "./CareerForm.svelte";
	import translations from "./CareerForm.translations.json";
	import type { Position } from "../../../../core/schema/Position.js";
	import { getTranslate } from "../../utils/getTranslate.js";

	export let show = false;
	export let position: Position | undefined = undefined;

	const translate = getTranslate(translations);
</script>

<Modal
	bind:show
	class="border-ltprimary-300 max-h-[90dvh] !rounded-none border !bg-white !p-0 lg:w-[46.25rem]"
	headerClass="sticky top-0 z-10 !mb-0 items-center bg-white px-8 pb-4 pt-8"
	closeLabel={translate("close")}
	fullscreenOnMobile
	noBackdrop
>
	<h2 slot="title" class="text-ltprimary font-roboto text-2md/none m-0 min-w-0 font-normal uppercase tracking-[0.02em]">
		{translate("title")}
	</h2>
	<CareerForm {position} on:close={() => (show = false)} />
</Modal>
